/* eslint-disable import/no-cycle */
import VueStore from '@/store';
import ContactLayout from '../layouts/ContactLayout.vue';

const Contact = () => import('../views/Contact/Contact.vue');

export default {
  path: '/kontakt',
  component: ContactLayout,
  children: [
    {
      path: '/',
      name: 'Auth.Contact',
      component: Contact,
      meta: {
        unauthorized: true,
        background: 'white',
      },
      beforeEnter(to, from, next) {
        const student = VueStore.getters['students/getStudent'];
        const { group } = student || {};
        const { lector, agency } = group || {};
        if (!student) {
          next({ name: 'Auth.Welcome' });
        } else if (!lector && !agency) {
          next({ name: 'Main.OnlineMaterials' });
        } else {
          next();
        }
      },
    },
  ],
};
